module.exports = __webpack_public_path__ + "static/media/pink-citrus.1d438e47.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/pink-citrus.jpeg
// module id = 2032
// module chunks = 0